import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
@Component({
  selector: 'atram-textbox',
  templateUrl: './atram-textbox.component.html',
  styleUrls: ['./atram-textbox.component.less']
})
export class AtramTextboxComponent implements OnInit {

  public isEyesHide: boolean = true;

  @Input()
  parentFormGroup!: FormGroup;
  @Input()
  type!: string;
  @Input()
  controlName!: string;
  @Input()
  label!: string;
  @Input()
  placeholder!: string;
  @Input()
  maxlength!: string;
  @Input()
  textColor!: string;
  @Input() showButton: boolean | undefined = false;
  @Input() showSearchButton: boolean | undefined = false;
  @Input() showEyeButton: boolean | undefined = false;
  @Input() isRequired: boolean | undefined = false;
  @Input() isError: boolean | undefined = false;
  @Input() isDisabled: boolean | undefined = false;
  @Input() showPhNumber: boolean | undefined = false;
  @Input('no-special-char') noSpecialChar: boolean = false; // directive
  @Input('number-only') numberOnly: boolean = false; // directive
  // @Input('upper-case') upperCase: boolean = false; // directive
  @Input()
  componentClass!: string;
  @Output('on-search') onSearchEmitter: EventEmitter<string>;
  @Output('on-click') onClickEmitter: EventEmitter<any>;

  constructor() {
    this.onSearchEmitter = new EventEmitter<string>();
    this.onClickEmitter = new EventEmitter<void>();
 }

  ngOnInit() {
  }

  public onSearch(event: Event): void {
    let value: any = (event.target as HTMLInputElement).value;
    this.onSearchEmitter.emit(value);
  }


  public onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.onClickEmitter.emit(event);
  }

  public onClickEye(){
    this.isEyesHide = !this.isEyesHide;

    if(this.showEyeButton && this.isEyesHide){
      this.type = "password";
    }
    else if(this.showEyeButton && !this.isEyesHide){
      this.type="text";
    }
  }
}
